module.exports = __webpack_public_path__ + "img/tm.48622e10.svg";